<div class="betriebskontakt-haendler-zuordnen" [class.dialog-mode]="dialog">
    <!-- Anzeige des aktuellen Kontakts -->
    <div *ngIf="betriebskontaktHaendler && !betriebskontaktHaendlerLoading" class="current-haendler">
        <h4>Aktueller Kontakt:</h4>
        <kiene-betriebskontakt-card
            [kontakt]="betriebskontaktHaendler"
            [config]="{
                showActions: true,
                showMenu: false,
                showFavorit: false,
                showBadge: true,
                compact: true,
                selectedMode: true
            }"
            (entfernen)="onBetriebskontaktEntfernen()"
        >
        </kiene-betriebskontakt-card>
    </div>

    <!-- Loading State -->
    <div *ngIf="betriebskontaktHaendlerLoading" class="loading-state">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Lade Kontakt-Daten...</span>
    </div>

    <!-- Kein Kontakt zugeordnet -->
    <div *ngIf="!betriebskontaktHaendler && !betriebskontaktHaendlerLoading" class="no-haendler">
        <p>Kein Kontakt zugeordnet</p>
    </div>

    <!-- Kontakt-Auswahl -->
    <div class="haendler-auswahl">
        <h4>Kontakt auswählen:</h4>

        <!-- Speichern-Indikator -->
        <div *ngIf="isLoading" class="saving-indicator">
            <mat-spinner diameter="16"></mat-spinner>
            <span>Speichere Kontakt...</span>
        </div>

        <kiene-betriebskontakt-auswahl
            [config]="{
                showLandwirte: true,
                showHaendler: true,
                showSchlachthoefe: true,
                showAll: true,
                multiSelect: false,
                compact: true,
                title: 'Kontakt auswählen',
                placeholder: 'Kontakt suchen...',
                allowCreateNew: true,
                keepOpenOnSelect: false
            }"
            [selectedKontakte]="betriebskontaktHaendler ? [betriebskontaktHaendler] : []"
            [disabled]="isLoading"
            (kontaktSelected)="onBetriebskontaktSelected($event)"
            (kontakteSelected)="onBetriebskontakteSelected($event)"
        >
        </kiene-betriebskontakt-auswahl>
    </div>

    <!-- Aktionen -->
    <div class="actions" *ngIf="!dialog">
        <button mat-raised-button color="primary" [disabled]="!betriebskontaktHaendler || isLoading" (click)="save()">
            <mat-spinner *ngIf="isLoading" diameter="16" style="margin-right: 8px"></mat-spinner>
            <span *ngIf="!isLoading">{{ buttonText }}</span>
            <span *ngIf="isLoading">Speichern...</span>
        </button>
    </div>

    <!-- Dialog-spezifische Aktionen -->
    <ng-content select="additional-actions"></ng-content>
</div>
